module.exports = __WEBPACK_EXTERNAL_MODULE_56__;


//////////////////
// WEBPACK FOOTER
// external {"root":"@material/snackbar/dist/mdc.snackbar","commonjs2":"@material/snackbar/dist/mdc.snackbar","commonjs":"@material/snackbar/dist/mdc.snackbar","amd":"@material/snackbar/dist/mdc.snackbar","umd":"@material/snackbar/dist/mdc.snackbar"}
// module id = 56
// module chunks = 0